import styled from "styled-components";

import { Dropdown, EllipsisDropdownItem, SimpleChipItemWrap } from "@similarweb/ui-components";

export const REVEAL_STATUS_DROPDOWN_WIDTH = 320;

export const StyledRevealStatusDropdown = styled(Dropdown)`
    padding: 8px;
`;
export const StyledSimpleChipItemWrap = styled(SimpleChipItemWrap)<{ isDisabled?: boolean }>`
    pointer-events: ${({ isDisabled }) => (isDisabled ? "none" : "auto")} !important;
`;

export const StyledRevealStatusDropdownItem = styled(EllipsisDropdownItem)<{ depth: number }>`
    display: flex !important;
    padding-left: ${({ depth }) => 16 + 32 * depth}px;
    margin-left: 8px;
    margin-right: 8px;

    &:first-of-type {
        margin-top: 8px;
    }

    &:last-of-type {
        margin-bottom: 8px;
    }
`;
